
const NonLoginHeader = () => {
    return(
            <div className=" bg-orange-300 rounded-xl shadow-xl">
                <div className=' mx-2 p-2 text-shadow-md shadow-slate-800 text-xl'>
                    Meal Garage
                </div>
            </div>
    )
}

export default NonLoginHeader